import { Component, Input } from '@angular/core';

/**
 * cp-help-tip — reusable info (i) button that reveals supplementary help text
 * on click/focus/hover via Kendo's tooltip. Accessible by default: it is a real
 * <button>, so it works for mouse, touch, and keyboard, and exposes the help
 * text to assistive tech via aria-label.
 *
 * Usage:
 *   <cp-help-tip text="Longer explanation shown on demand."></cp-help-tip>
 */
@Component({
    selector: 'cp-help-tip',
    templateUrl: './help-tip.component.html',
    styleUrls: ['./help-tip.component.scss']
})
export class HelpTipComponent {
    /** The supplementary text shown in the tooltip. */
    @Input() text: string = '';
    /** Accessible label for the trigger. Defaults to 'More information'. */
    @Input() ariaLabel: string = 'More information';
    /** Tooltip position relative to the icon. */
    @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
}
